/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import { message, Table, Input, Tooltip, Dropdown, Menu, Tag } from "antd";
import { SearchOutlined, MoreOutlined, EditOutlined } from "@ant-design/icons";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { serialNum, capitaliseWithHyphen } from "../../../utils";
import useCustomNavigate from "../../../components/customNavigationHook";
import Highlighter from "react-highlight-words";
import balance from "../../../assests/images/balance.svg";
import {
  CheckCircleOutlined,
  StopOutlined,
  //EyeOutlined,
} from "@ant-design/icons";

import { customerOnboardingAPI } from "../../../api/LeadApi";

//import "./style.scss";

function MasterCustomerList({
  userType,
  tabKey,
  url,
  filter,
  apiUrl,
  role,
  actionEdit,
  showWallet,
  basicEdit,
}) {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageSize, setTotalPageSize] = useState("");
  const [filters, setFilters] = useState({});
  const [debouncedFilters, setDebouncedFilters] = useState({});
  const navigate = useCustomNavigate();

  useEffect(() => {
    getInitialCustomerList();
  }, []);

  const getInitialCustomerList = () => {
    getLeadList({
      pageNum: 0,
      pageSize: 20,
      //customerType: userType,
    });
  };

  const getLeadList = async (params) => {
    setLoading(true);
    const response = await customerOnboardingAPI.getMasteList(
      {
        ...params,
        ...filter,
      },
      apiUrl
    );
    // (await userType) === "COMPANY"
    //   ? await customerOnboardingAPI.getCompanyByCP({
    //       ...params,
    //       ...filter,
    //     })
    //   : await customerOnboardingAPI.getAllLeadListWithoutPremise({
    //       ...params,
    //       status: "APPROVED",
    //       ...filter,
    //     });
    if (response?.status) {
      const res = response?.response?.data;
      setTotalPageSize(res?.count);
      setLoading(false);
      setTableData(
        res?.data?.map(
          (item) =>
            ({
              ...item,
              contactNumbers:
                item?.contactNumbers?.find((e) => e?.type === "default")
                  ?.number ||
                item?.contactNumbers?.[0]?.number ||
                "N/A",
              emails:
                item?.emails?.find((e) => e?.type === "personal")?.email ||
                item?.emails?.[0]?.email ||
                "N/A",
            } || [])
        )
      );
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Network Error");
    }
  };
  const reRoute = (pathName, record) => {
    navigate(pathName, {
      state: {
        tabKey: tabKey,
        reRoute: url,
        heading: "Master Details",
        cpId: record?.customerData?.cpId,
        basicEdit,
        apiUrl,
      },
    });
  };

  useEffect(() => {
    if (debouncedFilters && Object.keys(debouncedFilters).length > 0) {
      const handler = setTimeout(() => {
        getLeadList({
          pageNum: 0,
          pageSize: pageSize,
          //customerType: userType,
          ...debouncedFilters,
        });
      }, 500);
      setPageNum(0);
      setCurrentPage(1);
      return () => clearTimeout(handler);
    }
  }, [debouncedFilters]);

  const handleTableChange = (pagination, filters) => {
    if (filters?.customerData) {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
        //customerType: userType,
        isActive: filters?.customerData[0],
        ...debouncedFilters,
      });
    } else {
      getLeadList({
        pageNum: pagination?.current - 1 || 0,
        pageSize: pagination.pageSize,
        ...debouncedFilters,
        //customerType: userType,
      });
    }
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    setCurrentPage(pagination.current);
  };

  const handleSearch = (value, dataIndex) => {
    const updatedFilters = {
      ...filters,
      [dataIndex]: value?.toString(),
    };
    setFilters(updatedFilters);
    setDebouncedFilters(updatedFilters);
  };

  const getColumnSearchProps = (dataIndex, label = dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          allowClear
          placeholder={`Search ${label || dataIndex}`}
          value={selectedKeys[0] || ""}
          onChange={(e) => {
            const value = e.target.value ? [e.target.value] : [];
            setSelectedKeys(value);
            handleSearch(e.target.value, dataIndex);
          }}
        />
      </div>
    ),
    filterIcon: () => {
      return (
        <SearchOutlined
          style={{
            color: filters[dataIndex] ? "#1890ff" : undefined,
            fontSize: "16px",
          }}
        />
      );
    },

    render: (text) => {
      return filters[dataIndex] ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[filters[dataIndex]]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        formatText(text, 25) || "N/A"
      );
    },
  });

  const handleEnableDisable = async (record) => {
    let response = await customerOnboardingAPI.enableDisableCustomer(
      record?.customerId,
      {
        status: !record?.customerData?.isActive,
      }
    );
    if (response?.status) {
      let msg = record?.customerData?.isActive
        ? "Disabled successfully"
        : "Enabled successfully";
      message.success(response?.response?.data?.message || msg);
      getLeadList({
        pageNum: pageNum,
        pageSize: pageSize,
        ...filters,
      });
    } else {
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };
  const getTableColumns = () => {
    const baseColumns = [
      {
        title: "SI",
        width: 60,
        dataIndex: "sl",
        fixed: "left",
        align: "center",
        render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
      },
      {
        title: `${capitaliseWithHyphen(userType)} Name`,
        dataIndex: "orgName",
        key: "orgName",
        width: 150,
        ...getColumnSearchProps(
          "orgName",
          `${capitaliseWithHyphen(userType)} Name`
        ),
        render: (text, record) => {
          let customerId = null;
          if (userType === "COMPANY") {
            customerId = record?.customerData?.companyId;
          } else if (userType === "CLIENT") {
            customerId = record?.customerData?.clientLocationId;
          } else if (userType === "CP") {
            customerId = record?.customerData?.cpId;
          }

          return (
            <a
              onClick={() => reRoute(`/customer-details/${customerId}`, record)}
            >
              {formatText(text, 25)}
            </a>
          );
        },
      },
      {
        title: "Onboarded Date",
        dataIndex: "createdDate",
        key: "createdDate",
        width: 100,
        render: (_, record) => (
          <div>{record?.createdDate?.split(" ")?.[0] || "---"}</div>
        ),
      },
      {
        title: "Phone number",
        dataIndex: "contactNumbers",
        key: "contactNumbers",
        width: 100,
        render: (text) => text || "N/A",
        ...getColumnSearchProps("contactNumber", "Phone Number"),
      },
      {
        title: "Email",
        dataIndex: "emails",
        key: "emails",
        width: 80,
        align: "left",
        render: (text) => text || "N/A",
        ...getColumnSearchProps("email", "Email"),
      },
      {
        title: "State",
        dataIndex: "addresses",
        key: "addresses_state",
        width: 80,
        align: "left",
        render: (text) =>
          formatText(text?.find((e) => e.type === "DEFAULT")?.state, 15),
      },
      {
        title: "City",
        dataIndex: "addresses",
        key: "addresses_city",
        width: 100,
        align: "left",
        render: (text) =>
          formatText(text?.find((e) => e.type === "DEFAULT")?.city, 15),
      },
      {
        title: "Status",
        dataIndex: "customerData",
        key: "customerData",
        width: 70,
        align: "center",
        filters: [
          { value: true, text: "Active" },
          { value: false, text: "In-Active" },
        ],
        filterMultiple: false,
        render: (text) =>
          text?.isActive ? (
            <button className="active-button">Active</button>
          ) : (
            <button className="inActive-button">In-Active</button>
          ),
      },
      {
        title: "Actions",
        key: "action",
        align: "center",
        width: 100,
        render: (_, record) => {
          const prospayCustomerId = record?.metadata?.find(
            (e) => e?.key === "PROSPAY_CUSTOMER_ID"
          )?.value;
          let customerId = null;
          if (userType === "COMPANY") {
            customerId = record?.customerData?.companyId;
          } else if (userType === "CLIENT") {
            customerId = record?.customerData?.clientLocationId;
          } else if (userType === "CP") {
            customerId = record?.customerData?.cpId;
          }
          const menu = (
            <Menu
              items={[
                {
                  key: "toggleStatus",
                  label: record?.customerData?.isActive ? (
                    <span onClick={() => handleEnableDisable(record)}>
                      <StopOutlined style={{ color: "red", marginRight: 8 }} />
                      Disable
                    </span>
                  ) : (
                    <span onClick={() => handleEnableDisable(record)}>
                      <CheckCircleOutlined
                        style={{ color: "green", marginRight: 8 }}
                      />
                      Enable
                    </span>
                  ),
                },
                ...(basicEdit
                  ? [
                      {
                        key: "edit",
                        label: (
                          <span
                            onClick={() =>
                              reRoute(`/customer-details/${customerId}`, record)
                            }
                          >
                            <EditOutlined style={{ marginRight: 8 }} />
                            Edit
                          </span>
                        ),
                      },
                    ]
                  : []),
                ...(showWallet
                  ? [
                      {
                        key: "balance",
                        label: (
                          <span
                            onClick={() =>
                              navigate("/my-wallet", {
                                state: { prospayCustomerId, url, tabKey },
                              })
                            }
                          >
                            <img src={balance} alt="balance" /> Wallet
                          </span>
                        ),
                      },
                    ]
                  : []),
              ]}
            />
          );

          return (
            <Dropdown overlay={menu} trigger={["click"]}>
              <Tooltip title="Actions">
                <MoreOutlined />
              </Tooltip>
            </Dropdown>
          );
        },
      },
    ];

    // 🔁 Dynamic column inserts
    const insertColumns = [];

    // 1. Created By column
    if (role === "CP") {
      insertColumns.push({
        index: 2,
        column: {
          title: "Created By",
          dataIndex: "reference",
          key: "reference",
          width: 120,
          render: (text) => text || "N/A",
        },
      });
    }

    // 2. CP Name column (for COMPANY)
    if (userType === "COMPANY") {
      insertColumns.push({
        index: 2,
        column: {
          title: "CP Name",
          dataIndex: "cpName",
          key: "cpName",
          width: 150,
          render: (text) => formatText(text, 15),
        },
      });
    }

    // 3. Rate Card column (if NOT CP)
    if (userType !== "CP") {
      insertColumns.push({
        index: baseColumns.length - 2,
        column: {
          title: "Rate Card",
          dataIndex: "quotations",
          key: "quotations",
          width: 80,
          align: "left",
          render: (text, record) =>
            text?.length === 0
              ? "N/A"
              : text?.map(
                  (e, i) =>
                    e?.rateCardName && (
                      <React.Fragment key={i}>
                        <Tag
                          className="pointer tag-ant-cash"
                          style={{
                            minWidth: "70%",
                            marginTop: "2px",
                            fontSize: "10px",
                          }}
                          color={
                            e?.rateCardType?.toUpperCase() === "CASH"
                              ? "cyan"
                              : "geekblue"
                          }
                          onClick={() =>
                            navigate("/ratecards", {
                              state: {
                                rateCard: e?.rateCardName,
                                url,
                                tabKey,
                                actionEdit,
                                customerId: record?.customerId,
                                rateCardType: e?.rateCardType,
                              },
                            })
                          }
                        >
                          {e?.rateCardType}
                        </Tag>
                        <br />
                      </React.Fragment>
                    )
                ),
        },
      });
    }

    // 🔁 Insert extra columns at proper indexes
    insertColumns.forEach(({ index, column }) => {
      baseColumns.splice(index, 0, column);
    });

    return baseColumns;
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const formatText = (name, charLength = 15) => {
    if (!name) return "N/A";
    return (
      <>
        {name?.length > charLength ? (
          <Tooltip title={name} placement="bottom">
            {name?.length > charLength
              ? `${name?.substring(0, charLength)}..`
              : name}
          </Tooltip>
        ) : (
          name
        )}
      </>
    );
  };

  return (
    <div className="master-main-container cp-approval-list table-container">
      <Table
        //className="table-head-sticky"
        rowClassName={(record) => {
          if (record?.customerType?.toUpperCase() !== "CLIENT") return "";

          const address = record?.addresses?.find(
            (e) => e?.type?.toUpperCase() === "DEFAULT"
          );

          const isInvalid = [
            record?.emails,
            record?.contactNumbers,
            address?.street,
            address?.area,
          ].some((field) => !field || field === "N/A" || field === "");

          return isInvalid ? "hightlight-client-row" : "";
        }}
        loading={{
          indicator: (
            <img
              src={Smcs_Loader}
              style={{ height: "100px", width: "100px" }}
            />
          ),
          spinning: loading,
        }}
        columns={getTableColumns()}
        defaultCurrent={1}
        onChange={handleTableChange}
        //onChange={handlePageChange}
        dataSource={tableData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,

          total: totalPageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          //showSizeChanger: true,
          itemRender: itemRender,
        }}
      />
    </div>
  );
}

export default MasterCustomerList;
